import React, { Component } from 'react';
import { Tooltip } from 'bootstrap';

export class TDMExpander extends Component {
	constructor(props) {
		super(props)
	}

    componentDidMount() {
        const addressFlags = [[1, 0, 0, 0], [0, 1, 0, 0], [1, 1, 0, 0], [0, 0, 1, 0], [1, 0, 1, 0], [0, 1, 1, 0], [1, 1, 1, 0], [0, 0, 0, 1], [1, 0, 0, 1], [0, 1, 0, 1], [1, 1, 0, 1], [0, 0, 1, 1], [1, 0, 1, 1], [0, 1, 1, 1], [1, 1, 1, 1]];

        const addr = addressFlags[this.props.address - 1];
        var parent = document.querySelector('#tdm-' + this.props.address);

        new Tooltip(parent.querySelector('#d3LED'), { title: 'Indicates when a input changes state.' })

        // Headers

        new Tooltip(parent.querySelector('#relay1'), { title: "Switched 12VDC 500mA power supply for door strikes.<br /><strong>Cable Spec:</strong> 18AWG up to 152m (500′)", html: true});
        new Tooltip(parent.querySelector('#relay4'), { title: "Switched 12VDC 500mA power supply for door strikes.<br /><strong>Cable Spec:</strong> 18AWG up to 152m (500′)", html: true });

        for (var n of [1,2,4,5])
            new Tooltip(parent.querySelector('#relay' + (n + 1)), { title: "Normally open dry relay: 30V DC 1A limit<br /><strong>Cable Spec:</strong> 22AWG up to 152m (500′)", html: true });

        new Tooltip(parent.querySelector('#powerOutput'), { title: "Auxiliary 12VDC 500mA power supply for accessories such as motion detectors.<br /><strong>Cable Spec:</strong> 22AWG up to 152m (500′)", html: true });

        new Tooltip(parent.querySelector('#input12'), { title: "Dry contact inputs 1 & 2 with a shared ground.<br /><strong>Cable Spec:</strong> 22AWG Shielded up to 152m (500′)", html: true });
        new Tooltip(parent.querySelector('#input34'), { title: "Dry contact inputs 3 & 4 with a shared ground.<br /><strong>Cable Spec:</strong> 22AWG Shielded up to 152m (500′)", html: true });
        new Tooltip(parent.querySelector('#input56'), { title: "Dry contact inputs 5 & 6 with a shared ground.<br /><strong>Cable Spec:</strong> 22AWG Shielded up to 152m (500′)", html: true });


        new Tooltip(parent.querySelector('#reader1'), { title: "Reader 1 Wiegand Connection.<br /><strong>Ground:</strong>Black and shield wires<br /><strong>Power (12V DC):</strong> Red wire<br /><strong>LED:</strong> Brown wire<br /><strong>Buzzer:</strong> Blue wire<br /><strong>Data 1:</strong> White wire<br /><strong>Data 0:</strong> Green wire<br /><strong>Cable Spec:</strong> 24AWG Stranded, 100% Shielded up to 152m (500′)", html: true });
        new Tooltip(parent.querySelector('#reader2'), { title: "Reader 2 Wiegand Connection.<br /><strong>Ground:</strong>Black and shield wires<br /><strong>Power (12V DC):</strong> Red wire<br /><strong>LED:</strong> Brown wire<br /><strong>Buzzer:</strong> Blue wire<br /><strong>Data 1:</strong> White wire<br /><strong>Data 0:</strong> Green wire<br /><strong>Cable Spec:</strong> 24AWG Stranded, 100% Shielded up to 152m (500′)", html: true });

        new Tooltip(parent.querySelector('#rs485Header'), { title: 'RS-485 connection to main controller. <br /> Connected using a PRS-STRIP inside of an enclosure or using 22AWG shielded wire up to 1200m or 4000ft.', html: true, placement: 'left' })

        // Dip Switches

        var msg = "&nbsp;";
        for (n = 0; n < 15; n++) {
            msg += "<span class='text-danger'>" + (n + 1) + "</span> "
            if ((n + 1) < 10)
                msg += "&nbsp;";
            msg += addressFlags[n].join("") + "&nbsp;"
            if ((n + 1) % 3 === 0)
                msg += "<br />" + ((n + 1) !== 15 ? "&emsp;" : "")

        }

        new Tooltip(parent.querySelector('#dipswitch'), {
            title: '5 DIP switches to configure board address and functions<br />' +
                '<div class="text-start font-monospace"><strong>A0-A3:</strong> Board Address (1-15)<br />' + msg + '<strong>F0:</strong> Test Mode</div>', html: true
        })

        parent.querySelector('#sw1').setAttribute("class", "switch " + (addr[0] === 1 ? "on" : "off"));
        parent.querySelector('#sw2').setAttribute("class", "switch " + (addr[1] === 1 ? "on" : "off"));
        parent.querySelector('#sw3').setAttribute("class", "switch " + (addr[2] === 1 ? "on" : "off"));
        parent.querySelector('#sw4').setAttribute("class", "switch " + (addr[3] === 1 ? "on" : "off"));
        parent.querySelector('#sw5').setAttribute("class", "switch off");

        const selectors = parent.querySelectorAll(".switch")
        for (var n of selectors)
            n.addEventListener('pointerup', (e) => {
                e.target.parentElement.setAttribute("class", e.target.parentElement.getAttribute("class") === "switch off" ? "switch on" : "switch off");
            });
    }

    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                id={"tdm-" + this.props.address}
                className="tdm"
                width="350"
                height="350"
                version="1.1"
                viewBox="0 0 350 350"
            >
                <style id="style9683">
                    .green-led-fast { } .yellow-led-fast { } .green-led-slow { } .switch { }{" "}
                    .off { } .on { } .green-led { } .red-led { } .yellow-led { } .led { }{" "}
                    .header-background { } .header { }
                </style>
                <defs id="defs6">
                    <clipPath id="clipPath26" clipPathUnits="userSpaceOnUse">
                        <path id="path24" d="M0 612h792V0H0z"></path>
                    </clipPath>
                    <clipPath id="clipPath106" clipPathUnits="userSpaceOnUse">
                        <path id="path104" d="M0 612h792V0H0z"></path>
                    </clipPath>
                </defs>
                <g id="g10" transform="matrix(1.33333 0 0 -1.33333 0 816.298)">
                    <g id="g400" transform="matrix(.99985 0 0 1 .04 .224)">
                        <path
                            id="path14"
                            fill="#318e4e"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            strokeWidth="0.999"
                            d="M262.5 349.5H0v51.717h17.023v4.72H0v18.866h17.023v4.882H0V612h262.5z"
                            display="inline"
                        ></path>
                        <path
                            id="path18"
                            fill="none"
                            stroke="#30844c"
                            strokeDasharray="none"
                            strokeLinecap="butt"
                            strokeLinejoin="miter"
                            strokeMiterlimit="10"
                            strokeOpacity="1"
                            strokeWidth="0.499"
                            d="M262.25 349.75H.25v51.618h16.99v4.71H.25v18.831h16.99v4.873H.25V611.75h262z"
                            display="inline"
                        ></path>
                        <g id="g22" clipPath="url(#clipPath26)" display="inline">
                            <g id="g481" transform="translate(31.376 -3.605)">
                                <path
                                    id="path30"
                                    fill="#d4e5d8"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M209.145 597.625a6.875 6.875 0 10-13.75 0 6.875 6.875 0 0013.75 0"
                                ></path>
                                <path
                                    id="path34"
                                    fill="none"
                                    stroke="#a3a4a3"
                                    strokeDasharray="none"
                                    strokeLinecap="butt"
                                    strokeLinejoin="miter"
                                    strokeMiterlimit="10"
                                    strokeOpacity="1"
                                    strokeWidth="1"
                                    d="M209.645 597.125a6.875 6.875 0 10-13.75 0 6.875 6.875 0 0013.75 0z"
                                    display="inline"
                                ></path>
                            </g>
                            <g id="g477" transform="translate(4.432 -3.605)">
                                <path
                                    id="path38"
                                    fill="#d4e5d8"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M25.5 597.125a6.875 6.875 0 10-13.75 0 6.875 6.875 0 0013.75 0"
                                    display="inline"
                                ></path>
                                <path
                                    id="path42"
                                    fill="none"
                                    stroke="#a3a4a3"
                                    strokeDasharray="none"
                                    strokeLinecap="butt"
                                    strokeLinejoin="miter"
                                    strokeMiterlimit="10"
                                    strokeOpacity="1"
                                    strokeWidth="1"
                                    d="M25.5 597.125a6.875 6.875 0 10-13.75 0 6.875 6.875 0 0013.75 0z"
                                    display="inline"
                                ></path>
                            </g>
                            <g id="g473" transform="translate(.682 -16.513)">
                                <path
                                    id="path46"
                                    fill="#d4e5d8"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M29.25 397.033a6.875 6.875 0 10-13.75 0 6.875 6.875 0 0013.75 0"
                                    display="inline"
                                ></path>
                                <path
                                    id="path50"
                                    fill="none"
                                    stroke="#a3a4a3"
                                    strokeDasharray="none"
                                    strokeLinecap="butt"
                                    strokeLinejoin="miter"
                                    strokeMiterlimit="10"
                                    strokeOpacity="1"
                                    strokeWidth="1"
                                    d="M29.25 397.033a6.875 6.875 0 10-13.75 0 6.875 6.875 0 0013.75 0z"
                                    display="inline"
                                ></path>
                            </g>
                            <g id="g469" transform="translate(-37.535 -14.608)">
                                <path
                                    id="path54"
                                    fill="#d4e5d8"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M278.556 395.127a6.875 6.875 0 10-13.75 0 6.875 6.875 0 0013.75 0"
                                    display="inline"
                                ></path>
                                <path
                                    id="path58"
                                    fill="none"
                                    stroke="#a3a4a3"
                                    strokeDasharray="none"
                                    strokeLinecap="butt"
                                    strokeLinejoin="miter"
                                    strokeMiterlimit="10"
                                    strokeOpacity="1"
                                    strokeWidth="1"
                                    d="M278.556 395.127a6.875 6.875 0 10-13.75 0 6.875 6.875 0 0013.75 0z"
                                    display="inline"
                                ></path>
                            </g>
                        </g>
                        <g
                            id="g4867"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            display="inline"
                            transform="translate(0 -23.36)"
                        >
                            <path
                                id="path60"
                                fill="#856a3c"
                                d="M-.04 432.385h14.747v13.224H-.04z"
                                display="inline"
                            ></path>
                            <path
                                id="path70"
                                fill="#efd89d"
                                d="M13.134 433.34H1.255a1.294 1.294 0 000 2.59h11.88a1.294 1.294 0 000-2.59"
                                display="inline"
                            ></path>
                            <path
                                id="path66"
                                fill="#efd89d"
                                d="M13.134 437.654H1.255a1.294 1.294 0 000 2.589h11.88a1.294 1.294 0 100-2.59"
                                display="inline"
                            ></path>
                            <path
                                id="path62"
                                fill="#efd89d"
                                d="M-.04 441.942H14.43v2.59H-.04z"
                                display="inline"
                            ></path>
                        </g>
                    </g>
                    <text
                        xmlSpace="preserve"
                        style={{
                            InkscapeFontSpecification: "monospace",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontVariantNumeric: "normal",
                            fontVariantEastAsian: "normal",
                        }}
                        id="text8778"
                        x="-435.307"
                        y="-69.368"
                        fill="#fff"
                        fillOpacity="1"
                        strokeWidth="0.769"
                        display="inline"
                        fontFamily="monospace"
                        fontSize="7.177"
                        fontStretch="normal"
                        fontStyle="normal"
                        fontVariant="normal"
                        fontWeight="normal"
                        transform="matrix(0 -1.02531 -.97531 0 0 0)"
                    >
                        <tspan
                            id="tspan8776"
                            x="-435.307"
                            y="-69.368"
                            fill="#fff"
                            strokeWidth="0.769"
                            fontSize="7.177"
                        >
                            A0
                        </tspan>
                    </text>
                    <text
                        xmlSpace="preserve"
                        style={{
                            InkscapeFontSpecification: "monospace",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontVariantNumeric: "normal",
                            fontVariantEastAsian: "normal",
                        }}
                        id="text8782"
                        x="-434.738"
                        y="-76.061"
                        fill="#fff"
                        fillOpacity="1"
                        strokeWidth="0.77"
                        display="inline"
                        fontFamily="monospace"
                        fontSize="7.187"
                        fontStretch="normal"
                        fontStyle="normal"
                        fontVariant="normal"
                        fontWeight="normal"
                        transform="matrix(0 -1.02666 -.97404 0 0 0)"
                    >
                        <tspan
                            id="tspan8780"
                            x="-434.738"
                            y="-76.061"
                            fill="#fff"
                            strokeWidth="0.77"
                            fontSize="7.187"
                        >
                            A1
                        </tspan>
                    </text>
                    <text
                        xmlSpace="preserve"
                        style={{
                            InkscapeFontSpecification: "monospace",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontVariantNumeric: "normal",
                            fontVariantEastAsian: "normal",
                        }}
                        id="text8786"
                        x="-431.405"
                        y="-83.194"
                        fill="#fff"
                        fillOpacity="1"
                        strokeWidth="0.776"
                        display="inline"
                        fontFamily="monospace"
                        fontSize="7.242"
                        fontStretch="normal"
                        fontStyle="normal"
                        fontVariant="normal"
                        fontWeight="normal"
                        transform="matrix(0 -1.0346 -.96656 0 0 0)"
                    >
                        <tspan
                            id="tspan8784"
                            x="-431.405"
                            y="-83.194"
                            fill="#fff"
                            strokeWidth="0.776"
                            fontSize="7.242"
                        >
                            A2
                        </tspan>
                    </text>
                    <text
                        xmlSpace="preserve"
                        style={{
                            InkscapeFontSpecification: "monospace",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontVariantNumeric: "normal",
                            fontVariantEastAsian: "normal",
                        }}
                        id="text8790"
                        x="-433.313"
                        y="-89.394"
                        fill="#fff"
                        fillOpacity="1"
                        strokeWidth="0.773"
                        display="inline"
                        fontFamily="monospace"
                        fontSize="7.21"
                        fontStretch="normal"
                        fontStyle="normal"
                        fontVariant="normal"
                        fontWeight="normal"
                        transform="matrix(0 -1.03004 -.97084 0 0 0)"
                    >
                        <tspan
                            id="tspan8788"
                            x="-433.313"
                            y="-89.394"
                            fill="#fff"
                            strokeWidth="0.773"
                            fontSize="7.21"
                        >
                            A3
                        </tspan>
                    </text>
                    <text
                        xmlSpace="preserve"
                        style={{
                            InkscapeFontSpecification: "monospace",
                            fontVariantLigatures: "normal",
                            fontVariantCaps: "normal",
                            fontVariantNumeric: "normal",
                            fontVariantEastAsian: "normal",
                        }}
                        id="text8794"
                        x="-417.042"
                        y="-99.872"
                        fill="#fff"
                        fillOpacity="1"
                        strokeWidth="0.804"
                        display="inline"
                        fontFamily="monospace"
                        fontSize="7.505"
                        fontStretch="normal"
                        fontStyle="normal"
                        fontVariant="normal"
                        fontWeight="normal"
                        transform="matrix(0 -1.0721 -.93275 0 0 0)"
                    >
                        <tspan
                            id="tspan8792"
                            x="-417.042"
                            y="-99.872"
                            fill="#fff"
                            strokeWidth="0.804"
                            fontSize="7.505"
                        >
                            F0
                        </tspan>
                    </text>
                    <g id="g4507">
                        <g id="g3750" display="inline" transform="translate(-128.11 -35.796)">
                            <g id="g4569">
                                <text
                                    xmlSpace="preserve"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="text4281"
                                    x="344.834"
                                    y="-419.002"
                                    fill="red"
                                    strokeWidth="0.75"
                                    display="inline"
                                    fontFamily="monospace"
                                    fontSize="6"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                    transform="scale(1 -1)"
                                >
                                    <tspan
                                        id="tspan4279"
                                        style={{
                                            InkscapeFontSpecification: "'monospace, Normal'",
                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal",
                                        }}
                                        x="344.834"
                                        y="-419.002"
                                        fill="#fff"
                                        strokeWidth="0.75"
                                        fontFamily="monospace"
                                        fontSize="6"
                                        fontStretch="normal"
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight="normal"
                                    >
                                        D56
                                    </tspan>
                                </text>
                                <path
                                    id="reader2LED"
                                    fill="#ffcd00"
                                    fillOpacity="1"
                                    strokeWidth="0.75"
                                    d="M338.111 -422.812H343.51V-418.842H338.111z"
                                    className="led yellow-led"
                                    transform="scale(1 -1)"
                                ></path>
                            </g>
                            <g
                                id="g4564"
                                fontFamily="monospace"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                            >
                                <text
                                    xmlSpace="preserve"
                                    style={{ InkscapeFontSpecification: "monospace" }}
                                    id="text4273"
                                    x="380"
                                    y="-492.55"
                                    fill="#fff"
                                    fillOpacity="1"
                                    stroke="#fff"
                                    strokeDasharray="none"
                                    strokeOpacity="1"
                                    strokeWidth="0"
                                    display="inline"
                                    fontSize="14"
                                    writingMode="vertical-lr"
                                >
                                    <tspan
                                        id="tspan4271"
                                        style={{ InkscapeFontSpecification: "monospace" }}
                                        x="380"
                                        y="-492.55"
                                        fill="#fff"
                                        stroke="none"
                                        strokeDasharray="none"
                                        strokeWidth="0"
                                        fontFamily="monospace"
                                        fontSize="14"
                                        fontStretch="normal"
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight="normal"
                                        opacity="1"
                                    >
                                        READER 2
                                    </tspan>
                                </text>
                                <text
                                    xmlSpace="preserve"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="text4060"
                                    x="358.133"
                                    y="-432.119"
                                    fill="red"
                                    strokeWidth="0.75"
                                    fontSize="6"
                                >
                                    <tspan
                                        id="tspan4058"
                                        style={{
                                            InkscapeFontSpecification: "'monospace, Normal'",
                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal",
                                        }}
                                        x="358.133"
                                        y="-432.119"
                                        fill="#fff"
                                        strokeWidth="0.75"
                                        fontFamily="monospace"
                                        fontSize="6"
                                        fontStretch="normal"
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight="normal"
                                    >
                                        D0
                                    </tspan>
                                </text>
                                <text
                                    xmlSpace="preserve"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="text4046"
                                    x="358.133"
                                    y="-442.842"
                                    fill="red"
                                    strokeWidth="0.75"
                                    display="inline"
                                    fontSize="6"
                                >
                                    <tspan
                                        id="tspan4044"
                                        style={{
                                            InkscapeFontSpecification: "'monospace, Normal'",
                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal",
                                        }}
                                        x="358.133"
                                        y="-442.842"
                                        fill="#fff"
                                        strokeWidth="0.75"
                                        fontFamily="monospace"
                                        fontSize="6"
                                        fontStretch="normal"
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight="normal"
                                    >
                                        D1
                                    </tspan>
                                </text>
                                <text
                                    xmlSpace="preserve"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="text4052"
                                    x="358.133"
                                    y="-453.901"
                                    fill="red"
                                    strokeWidth="0.75"
                                    display="inline"
                                    fontSize="6"
                                >
                                    <tspan
                                        id="tspan4050"
                                        style={{
                                            InkscapeFontSpecification: "'monospace, Normal'",
                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal",
                                        }}
                                        x="358.133"
                                        y="-453.901"
                                        fill="#fff"
                                        strokeWidth="0.75"
                                        fontFamily="monospace"
                                        fontSize="6"
                                        fontStretch="normal"
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight="normal"
                                    >
                                        BUZ
                                    </tspan>
                                </text>
                                <text
                                    xmlSpace="preserve"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="text4040"
                                    x="358.133"
                                    y="-464.567"
                                    fill="red"
                                    strokeWidth="0.75"
                                    display="inline"
                                    fontSize="6"
                                >
                                    <tspan
                                        id="tspan4038"
                                        style={{
                                            InkscapeFontSpecification: "'monospace, Normal'",
                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal",
                                        }}
                                        x="358.133"
                                        y="-464.567"
                                        fill="#fff"
                                        strokeWidth="0.75"
                                        fontFamily="monospace"
                                        fontSize="6"
                                        fontStretch="normal"
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight="normal"
                                    >
                                        LED
                                    </tspan>
                                </text>
                                <text
                                    xmlSpace="preserve"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="text4034"
                                    x="358.133"
                                    y="-475.907"
                                    fill="red"
                                    strokeWidth="0.75"
                                    display="inline"
                                    fontSize="6"
                                >
                                    <tspan
                                        id="tspan4032"
                                        style={{
                                            InkscapeFontSpecification: "'monospace, Normal'",
                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal",
                                        }}
                                        x="358.133"
                                        y="-475.907"
                                        fill="#fff"
                                        strokeWidth="0.75"
                                        fontFamily="monospace"
                                        fontSize="6"
                                        fontStretch="normal"
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight="normal"
                                    >
                                        PWR
                                    </tspan>
                                </text>
                                <text
                                    xmlSpace="preserve"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="text4028"
                                    x="358.349"
                                    y="-486.694"
                                    fill="red"
                                    strokeWidth="0.75"
                                    display="inline"
                                    fontSize="6"
                                >
                                    <tspan
                                        id="tspan4026"
                                        style={{
                                            InkscapeFontSpecification: "'monospace, Normal'",
                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal",
                                        }}
                                        x="358.349"
                                        y="-486.694"
                                        fill="#fff"
                                        strokeWidth="0.75"
                                        fontFamily="monospace"
                                        fontSize="6"
                                        fontStretch="normal"
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight="normal"
                                    >
                                        GND
                                    </tspan>
                                </text>
                            </g>
                            <g id="reader2" className="header">
                                <path
                                    id="reader2Bg"
                                    fill="#63b47f"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M357.063 426.452H338.11v69.844h18.952z"
                                    className="header-background"
                                    display="inline"
                                ></path>
                                <path
                                    id="path230"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M353.632 437.224h2.554v-6.287h-2.554v1.849h-1.31v-3.621h-13.125v9.66h13.126v-3.373h1.309z"
                                    display="inline"
                                ></path>
                                <path
                                    id="path234"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M347.853 434.118a1.333 1.333 0 10-2.667 0 1.333 1.333 0 002.667 0"
                                    display="inline"
                                ></path>
                                <path
                                    id="path222"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M353.632 448.15h2.554v-6.286h-2.554v1.849h-1.31v-3.621h-13.125v9.66h13.126v-3.373h1.309z"
                                    display="inline"
                                ></path>
                                <path
                                    id="path226"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M347.853 445.046a1.333 1.333 0 10-2.666-.001 1.333 1.333 0 002.666 0"
                                    display="inline"
                                ></path>
                                <path
                                    id="path214"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M353.632 459.078h2.554v-6.287h-2.554v1.849h-1.31v-3.621h-13.125v9.661h13.126v-3.373h1.309z"
                                    display="inline"
                                ></path>
                                <path
                                    id="path218"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M347.853 455.973a1.333 1.333 0 10-2.667 0 1.333 1.333 0 002.667 0"
                                    display="inline"
                                ></path>
                                <path
                                    id="path206"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M353.632 470.006h2.554v-6.287h-2.554v1.848h-1.31v-3.62h-13.125v9.66h13.126v-3.373h1.309z"
                                    display="inline"
                                ></path>
                                <path
                                    id="path210"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M347.853 466.9a1.333 1.333 0 10-2.667 0 1.333 1.333 0 002.667 0"
                                    display="inline"
                                ></path>
                                <path
                                    id="path198"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M353.632 480.933h2.554v-6.287h-2.554v1.849h-1.31v-3.621h-13.125v9.661h13.126v-3.374h1.309z"
                                    display="inline"
                                ></path>
                                <path
                                    id="path202"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M347.853 477.828a1.333 1.333 0 10-2.667 0 1.333 1.333 0 002.667 0"
                                    display="inline"
                                ></path>
                                <path
                                    id="path190"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M353.632 491.86h2.554v-6.287h-2.554v1.85h-1.31V483.8h-13.125v9.661h13.126v-3.374h1.309z"
                                    display="inline"
                                ></path>
                                <path
                                    id="path194"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M347.853 488.755a1.333 1.333 0 10-2.667 0 1.333 1.333 0 002.667 0"
                                    display="inline"
                                ></path>
                            </g>
                        </g>
                        <g
                            id="reader1Group"
                            display="inline"
                            transform="translate(-128.11 81.204)"
                        >
                            <g id="g489">
                                <text
                                    xmlSpace="preserve"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="text485"
                                    x="344.834"
                                    y="-419.002"
                                    fill="red"
                                    strokeWidth="0.75"
                                    display="inline"
                                    fontFamily="monospace"
                                    fontSize="6"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                    transform="scale(1 -1)"
                                >
                                    <tspan
                                        id="tspan483"
                                        style={{
                                            InkscapeFontSpecification: "'monospace, Normal'",
                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal",
                                        }}
                                        x="344.834"
                                        y="-419.002"
                                        fill="#fff"
                                        strokeWidth="0.75"
                                        fontFamily="monospace"
                                        fontSize="6"
                                        fontStretch="normal"
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight="normal"
                                    >
                                        D55
                                    </tspan>
                                </text>
                                <path
                                    id="reader1LED"
                                    fill="#ffcd00"
                                    fillOpacity="1"
                                    strokeWidth="0.75"
                                    d="M338.111 -422.812H343.51V-418.842H338.111z"
                                    className="led yellow-led"
                                    transform="scale(1 -1)"
                                ></path>
                            </g>
                            <g
                                id="g519"
                                display="inline"
                                fontFamily="monospace"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                            >
                                <text
                                    xmlSpace="preserve"
                                    style={{ InkscapeFontSpecification: "monospace" }}
                                    id="text493"
                                    x="380"
                                    y="-492.85"
                                    fill="#fff"
                                    fillOpacity="1"
                                    stroke="#fff"
                                    strokeDasharray="none"
                                    strokeOpacity="1"
                                    strokeWidth="0"
                                    display="inline"
                                    fontSize="14"
                                    writingMode="vertical-lr"
                                >
                                    <tspan
                                        id="tspan491"
                                        style={{ InkscapeFontSpecification: "monospace" }}
                                        x="380"
                                        y="-492.85"
                                        fill="#fff"
                                        stroke="none"
                                        strokeDasharray="none"
                                        strokeWidth="0"
                                        fontFamily="monospace"
                                        fontSize="14"
                                        fontStretch="normal"
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight="normal"
                                        opacity="1"
                                    >
                                        READER 1
                                    </tspan>
                                </text>
                                <text
                                    xmlSpace="preserve"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="text497"
                                    x="358.133"
                                    y="-432.119"
                                    fill="red"
                                    strokeWidth="0.75"
                                    display="inline"
                                    fontSize="6"
                                >
                                    <tspan
                                        id="tspan495"
                                        style={{
                                            InkscapeFontSpecification: "'monospace, Normal'",
                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal",
                                        }}
                                        x="358.133"
                                        y="-432.119"
                                        fill="#fff"
                                        strokeWidth="0.75"
                                        fontFamily="monospace"
                                        fontSize="6"
                                        fontStretch="normal"
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight="normal"
                                    >
                                        D0
                                    </tspan>
                                </text>
                                <text
                                    xmlSpace="preserve"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="text501"
                                    x="358.133"
                                    y="-442.842"
                                    fill="red"
                                    strokeWidth="0.75"
                                    display="inline"
                                    fontSize="6"
                                >
                                    <tspan
                                        id="tspan499"
                                        style={{
                                            InkscapeFontSpecification: "'monospace, Normal'",
                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal",
                                        }}
                                        x="358.133"
                                        y="-442.842"
                                        fill="#fff"
                                        strokeWidth="0.75"
                                        fontFamily="monospace"
                                        fontSize="6"
                                        fontStretch="normal"
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight="normal"
                                    >
                                        D1
                                    </tspan>
                                </text>
                                <text
                                    xmlSpace="preserve"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="text505"
                                    x="358.133"
                                    y="-453.901"
                                    fill="red"
                                    strokeWidth="0.75"
                                    display="inline"
                                    fontSize="6"
                                >
                                    <tspan
                                        id="tspan503"
                                        style={{
                                            InkscapeFontSpecification: "'monospace, Normal'",
                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal",
                                        }}
                                        x="358.133"
                                        y="-453.901"
                                        fill="#fff"
                                        strokeWidth="0.75"
                                        fontFamily="monospace"
                                        fontSize="6"
                                        fontStretch="normal"
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight="normal"
                                    >
                                        BUZ
                                    </tspan>
                                </text>
                                <text
                                    xmlSpace="preserve"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="text509"
                                    x="358.133"
                                    y="-464.567"
                                    fill="red"
                                    strokeWidth="0.75"
                                    display="inline"
                                    fontSize="6"
                                >
                                    <tspan
                                        id="tspan507"
                                        style={{
                                            InkscapeFontSpecification: "'monospace, Normal'",
                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal",
                                        }}
                                        x="358.133"
                                        y="-464.567"
                                        fill="#fff"
                                        strokeWidth="0.75"
                                        fontFamily="monospace"
                                        fontSize="6"
                                        fontStretch="normal"
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight="normal"
                                    >
                                        LED
                                    </tspan>
                                </text>
                                <text
                                    xmlSpace="preserve"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="text513"
                                    x="358.133"
                                    y="-475.907"
                                    fill="red"
                                    strokeWidth="0.75"
                                    display="inline"
                                    fontSize="6"
                                >
                                    <tspan
                                        id="tspan511"
                                        style={{
                                            InkscapeFontSpecification: "'monospace, Normal'",
                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal",
                                        }}
                                        x="358.133"
                                        y="-475.907"
                                        fill="#fff"
                                        strokeWidth="0.75"
                                        fontFamily="monospace"
                                        fontSize="6"
                                        fontStretch="normal"
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight="normal"
                                    >
                                        PWR
                                    </tspan>
                                </text>
                                <text
                                    xmlSpace="preserve"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="text517"
                                    x="358.349"
                                    y="-486.694"
                                    fill="red"
                                    strokeWidth="0.75"
                                    display="inline"
                                    fontSize="6"
                                >
                                    <tspan
                                        id="tspan515"
                                        style={{
                                            InkscapeFontSpecification: "'monospace, Normal'",
                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal",
                                        }}
                                        x="358.349"
                                        y="-486.694"
                                        fill="#fff"
                                        strokeWidth="0.75"
                                        fontFamily="monospace"
                                        fontSize="6"
                                        fontStretch="normal"
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight="normal"
                                    >
                                        GND
                                    </tspan>
                                </text>
                            </g>
                            <g id="reader1" className="header">
                                <path
                                    id="reader1Bg"
                                    fill="#63b47f"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M357.063 426.452H338.11v69.844h18.952z"
                                    className="header-background"
                                    display="inline"
                                ></path>
                                <path
                                    id="path523"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M353.632 437.224h2.554v-6.287h-2.554v1.849h-1.31v-3.621h-13.125v9.66h13.126v-3.373h1.309z"
                                    display="inline"
                                ></path>
                                <path
                                    id="path525"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M347.853 434.118a1.333 1.333 0 10-2.667 0 1.333 1.333 0 002.667 0"
                                    display="inline"
                                ></path>
                                <path
                                    id="path527"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M353.632 448.15h2.554v-6.286h-2.554v1.849h-1.31v-3.621h-13.125v9.66h13.126v-3.373h1.309z"
                                    display="inline"
                                ></path>
                                <path
                                    id="path529"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M347.853 445.046a1.333 1.333 0 10-2.666-.001 1.333 1.333 0 002.666 0"
                                    display="inline"
                                ></path>
                                <path
                                    id="path531"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M353.632 459.078h2.554v-6.287h-2.554v1.849h-1.31v-3.621h-13.125v9.661h13.126v-3.373h1.309z"
                                    display="inline"
                                ></path>
                                <path
                                    id="path533"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M347.853 455.973a1.333 1.333 0 10-2.667 0 1.333 1.333 0 002.667 0"
                                    display="inline"
                                ></path>
                                <path
                                    id="path535"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M353.632 470.006h2.554v-6.287h-2.554v1.848h-1.31v-3.62h-13.125v9.66h13.126v-3.373h1.309z"
                                    display="inline"
                                ></path>
                                <path
                                    id="path537"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M347.853 466.9a1.333 1.333 0 10-2.667 0 1.333 1.333 0 002.667 0"
                                    display="inline"
                                ></path>
                                <path
                                    id="path539"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M353.632 480.933h2.554v-6.287h-2.554v1.849h-1.31v-3.621h-13.125v9.661h13.126v-3.374h1.309z"
                                    display="inline"
                                ></path>
                                <path
                                    id="path541"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M347.853 477.828a1.333 1.333 0 10-2.667 0 1.333 1.333 0 002.667 0"
                                    display="inline"
                                ></path>
                                <path
                                    id="path543"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M353.632 491.86h2.554v-6.287h-2.554v1.85h-1.31V483.8h-13.125v9.661h13.126v-3.374h1.309z"
                                    display="inline"
                                ></path>
                                <path
                                    id="path545"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M347.853 488.755a1.333 1.333 0 10-2.667 0 1.333 1.333 0 002.667 0"
                                    display="inline"
                                ></path>
                            </g>
                        </g>
                        <g id="g401" transform="translate(-148.079 68.41)">
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text887"
                                x="326.692"
                                y="-324.368"
                                fill="red"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="6"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                            >
                                <tspan
                                    id="tspan885"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    x="326.692"
                                    y="-324.368"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="6"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                >
                                    D36
                                </tspan>
                            </text>
                            <path
                                id="relay6LED"
                                fill="red"
                                strokeWidth="0.75"
                                d="M320.579 -328.179H325.978V-324.20899999999995H320.579z"
                                className="led red-led"
                                transform="scale(1 -1)"
                            ></path>
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text519"
                                x="345.438"
                                y="-356.212"
                                fill="#fff"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="8"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                                writingMode="vertical-lr"
                            >
                                <tspan
                                    id="tspan517"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    x="345.438"
                                    y="-356.212"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="8"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                    writingMode="vertical-lr"
                                >
                                    RELAY6
                                </tspan>
                            </text>
                            <g id="relay6" className="header">
                                <path
                                    id="relay6Bg"
                                    fill="#63b47f"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M339.646 329.42h-18.952v26.117h18.952z"
                                    className="header-background"
                                ></path>
                                <path
                                    id="path434"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.621h-13.126v9.661h13.126v-3.374H0z"
                                    transform="translate(336.217 340.17)"
                                ></path>
                                <path
                                    id="path438"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
                                    transform="translate(330.438 337.065)"
                                ></path>
                                <path
                                    id="path426"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.62h-13.126v9.66h13.126v-3.373H0z"
                                    transform="translate(336.217 351.098)"
                                ></path>
                                <path
                                    id="path430"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
                                    transform="translate(330.438 347.993)"
                                ></path>
                            </g>
                        </g>
                        <g id="g972" transform="translate(-148.079 104.41)">
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text954"
                                x="326.692"
                                y="-324.368"
                                fill="red"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="6"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                            >
                                <tspan
                                    id="tspan952"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    x="326.692"
                                    y="-324.368"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="6"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                >
                                    D34
                                </tspan>
                            </text>
                            <path
                                id="relay5LED"
                                fill="red"
                                strokeWidth="0.75"
                                d="M320.579 -328.179H325.978V-324.20899999999995H320.579z"
                                className="led red-led"
                                transform="scale(1 -1)"
                            ></path>
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text960"
                                x="345.438"
                                y="-356.212"
                                fill="#fff"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="8"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                                writingMode="vertical-lr"
                            >
                                <tspan
                                    id="tspan958"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    x="345.438"
                                    y="-356.212"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="8"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                    writingMode="vertical-lr"
                                >
                                    RELAY5
                                </tspan>
                            </text>
                            <g id="relay5" className="header">
                                <path
                                    id="relay5Bg"
                                    fill="#63b47f"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M339.646 329.42h-18.952v26.117h18.952z"
                                    className="header-background"
                                ></path>
                                <path
                                    id="path964"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.621h-13.126v9.661h13.126v-3.374H0z"
                                    transform="translate(336.217 340.17)"
                                ></path>
                                <path
                                    id="path966"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
                                    transform="translate(330.438 337.065)"
                                ></path>
                                <path
                                    id="path968"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.62h-13.126v9.66h13.126v-3.373H0z"
                                    transform="translate(336.217 351.098)"
                                ></path>
                                <path
                                    id="path970"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
                                    transform="translate(330.438 347.993)"
                                ></path>
                            </g>
                        </g>
                        <g id="g777" transform="translate(-148.079 139.69)">
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text759"
                                x="326.692"
                                y="-324.368"
                                fill="red"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="6"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                            >
                                <tspan
                                    id="tspan757"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    x="326.692"
                                    y="-324.368"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="6"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                >
                                    D30
                                </tspan>
                            </text>
                            <path
                                id="relay4LED"
                                fill="#ffcd00"
                                fillOpacity="1"
                                strokeWidth="0.75"
                                d="M320.579 -328.179H325.978V-324.20899999999995H320.579z"
                                className="led yellow-led"
                                transform="scale(1 -1)"
                            ></path>
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text765"
                                x="344.897"
                                y="-357.109"
                                fill="#fff"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="7"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                                writingMode="vertical-lr"
                            >
                                <tspan id="tspan724" x="344.897" y="-357.109">
                                    {" "} -  +
                                </tspan>
                                <tspan id="tspan726" x="353.647" y="-357.109">
                                    {" "}
                                    POWER
                                </tspan>
                                <tspan id="tspan728" x="362.397" y="-357.109">
                                    {" "}
                                    LOCK2
                                </tspan>
                                <tspan
                                    id="tspan730"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    x="371.147"
                                    y="-357.109"
                                    fontFamily="monospace"
                                    fontSize="6"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                >
                                    (RELAY4)
                                </tspan>
                            </text>
                            <g id="relay4" className="header">
                                <path
                                    id="relay4Bg"
                                    fill="#63b47f"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M339.646 329.42h-18.952v26.117h18.952z"
                                    className="header-background"
                                ></path>
                                <path
                                    id="path769"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.621h-13.126v9.661h13.126v-3.374H0z"
                                    transform="translate(336.217 340.17)"
                                ></path>
                                <path
                                    id="path771"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
                                    transform="translate(330.438 337.065)"
                                ></path>
                                <path
                                    id="path773"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.62h-13.126v9.66h13.126v-3.373H0z"
                                    transform="translate(336.217 351.098)"
                                ></path>
                                <path
                                    id="path775"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
                                    transform="translate(330.438 347.993)"
                                ></path>
                            </g>
                        </g>
                        <g id="g810" transform="translate(-148.079 179.41)">
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text792"
                                x="326.692"
                                y="-324.368"
                                fill="red"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="6"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                            >
                                <tspan
                                    id="tspan790"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    x="326.692"
                                    y="-324.368"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="6"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                >
                                    D27
                                </tspan>
                            </text>
                            <path
                                id="relay3LED"
                                fill="red"
                                strokeWidth="0.75"
                                d="M320.579 -328.179H325.978V-324.20899999999995H320.579z"
                                className="led red-led"
                                transform="scale(1 -1)"
                            ></path>
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text798"
                                x="345.438"
                                y="-356.265"
                                fill="#fff"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="8"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                                writingMode="vertical-lr"
                            >
                                <tspan
                                    id="tspan796"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    x="345.438"
                                    y="-356.265"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="8"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                    writingMode="vertical-lr"
                                >
                                    RELAY3
                                </tspan>
                            </text>
                            <g id="relay3" className="header">
                                <path
                                    id="relay3Bg"
                                    fill="#63b47f"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M339.646 329.42h-18.952v26.117h18.952z"
                                    className="header-background"
                                ></path>
                                <path
                                    id="path802"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.621h-13.126v9.661h13.126v-3.374H0z"
                                    transform="translate(336.217 340.17)"
                                ></path>
                                <path
                                    id="path804"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
                                    transform="translate(330.438 337.065)"
                                ></path>
                                <path
                                    id="path806"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.62h-13.126v9.66h13.126v-3.373H0z"
                                    transform="translate(336.217 351.098)"
                                ></path>
                                <path
                                    id="path808"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
                                    transform="translate(330.438 347.993)"
                                ></path>
                            </g>
                        </g>
                        <g id="g832" transform="translate(-148.079 216.91)">
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text814"
                                x="326.692"
                                y="-323.768"
                                fill="red"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="6"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                            >
                                <tspan
                                    id="tspan812"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    x="326.692"
                                    y="-323.768"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="6"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                >
                                    D26
                                </tspan>
                            </text>
                            <path
                                id="relay2LED"
                                fill="red"
                                strokeWidth="0.75"
                                d="M320.579 -328.179H325.978V-324.20899999999995H320.579z"
                                className="led red-led"
                                transform="scale(1 -1)"
                            ></path>
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text820"
                                x="345.358"
                                y="-356.34"
                                fill="#fff"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="8"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                                writingMode="vertical-lr"
                            >
                                <tspan
                                    id="tspan818"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    x="345.358"
                                    y="-356.34"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="8"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                    writingMode="vertical-lr"
                                >
                                    RELAY2
                                </tspan>
                            </text>
                            <g id="relay2" className="header">
                                <path
                                    id="relay2Bg"
                                    fill="#63b47f"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M339.646 329.42h-18.952v26.117h18.952z"
                                    className="header-background"
                                ></path>
                                <path
                                    id="path824"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.621h-13.126v9.661h13.126v-3.374H0z"
                                    transform="translate(336.217 340.17)"
                                ></path>
                                <path
                                    id="path826"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
                                    transform="translate(330.438 337.065)"
                                ></path>
                                <path
                                    id="path828"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.62h-13.126v9.66h13.126v-3.373H0z"
                                    transform="translate(336.217 351.098)"
                                ></path>
                                <path
                                    id="path830"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
                                    transform="translate(330.438 347.993)"
                                ></path>
                            </g>
                        </g>
                        <g id="g854" transform="translate(-148.079 251.405)">
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text836"
                                x="326.692"
                                y="-324.144"
                                fill="red"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="6"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                            >
                                <tspan
                                    id="tspan834"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    x="326.692"
                                    y="-324.144"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="6"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                >
                                    D25
                                </tspan>
                            </text>
                            <path
                                id="relay1LED"
                                fill="#ffcd00"
                                fillOpacity="1"
                                strokeWidth="0.75"
                                d="M320.579 -328.179H325.978V-324.20899999999995H320.579z"
                                className="led yellow-led"
                                transform="scale(1 -1)"
                            ></path>
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text3863"
                                x="344.897"
                                y="-358.72"
                                fill="#fff"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="7"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                                writingMode="vertical-lr"
                            >
                                <tspan id="tspan740" x="344.897" y="-358.72">
                                    {" "} -  +
                                </tspan>
                                <tspan id="tspan742" x="353.647" y="-358.72">
                                    {" "}
                                    POWER
                                </tspan>
                                <tspan id="tspan744" x="362.397" y="-358.72">
                                    {" "}
                                    LOCK1
                                </tspan>
                                <tspan
                                    id="tspan746"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    x="371.147"
                                    y="-358.72"
                                    fontFamily="monospace"
                                    fontSize="6"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                >
                                    (RELAY1)
                                </tspan>
                            </text>
                            <g id="relay1" className="header" transform="translate(0 .708)">
                                <path
                                    id="relay1Bg"
                                    fill="#63b47f"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M339.646 329.42h-18.952v26.117h18.952z"
                                    className="header-background"
                                ></path>
                                <path
                                    id="path846"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.621h-13.126v9.661h13.126v-3.374H0z"
                                    transform="translate(336.217 340.17)"
                                ></path>
                                <path
                                    id="path848"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
                                    transform="translate(330.438 337.065)"
                                ></path>
                                <path
                                    id="path850"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.62h-13.126v9.66h13.126v-3.373H0z"
                                    transform="translate(336.217 351.098)"
                                ></path>
                                <path
                                    id="path852"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
                                    transform="translate(330.438 347.993)"
                                ></path>
                            </g>
                        </g>
                        <g id="g3446" transform="translate(-70.914 54.747)">
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text3430"
                                x="225.204"
                                y="-331"
                                fill="#fff"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="7"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                            >
                                <tspan
                                    id="tspan3426"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    x="225.204"
                                    y="-331"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="7"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                >
                                    REQ
                                </tspan>
                                <tspan
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="tspan3428"
                                    x="225.204"
                                    y="-322.25"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="7"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                >
                                    EXIT
                                </tspan>
                            </text>
                            <g
                                id="input56"
                                className="header"
                                transform="matrix(1 0 0 -1 0 612.16)"
                            >
                                <path
                                    id="input56Bg"
                                    fill="#63b47f"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M264.837 296.604h-37.07v18.952h37.07z"
                                    className="header-background"
                                ></path>
                                <path
                                    id="input6"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0v-2.554h-6.287V0h1.849v1.31h-3.621v13.125h9.661V1.31h-3.374V0z"
                                    transform="translate(260.399 300.031)"
                                ></path>
                                <path
                                    id="path3436"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 100 2.667A1.333 1.333 0 000 0"
                                    transform="translate(257.294 305.81)"
                                ></path>
                                <path
                                    id="path3438"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0v-2.554h-6.287V0h1.849v1.31h-3.621v13.125h9.661V1.31h-3.374V0z"
                                    transform="translate(249.472 300.031)"
                                ></path>
                                <path
                                    id="path3440"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 100 2.667A1.333 1.333 0 000 0"
                                    transform="translate(246.366 305.81)"
                                ></path>
                                <path
                                    id="input5"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0v-2.554h-6.287V0h1.848v1.31h-3.62v13.125h9.661V1.31h-3.374V0z"
                                    transform="translate(238.544 300.031)"
                                ></path>
                                <path
                                    id="path3444"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 100 2.667A1.333 1.333 0 000 0"
                                    transform="translate(235.439 305.81)"
                                ></path>
                            </g>
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text3474"
                                x="-247.51"
                                y="321.457"
                                fill="#fff"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="7"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(-1 1)"
                                writingMode="vertical-lr"
                            >
                                <tspan
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="tspan3472"
                                    x="-247.51"
                                    y="321.457"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="7"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                    writingMode="vertical-lr"
                                >
                                    COM
                                </tspan>
                            </text>
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text3482"
                                x="253.227"
                                y="-331"
                                fill="#fff"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="7"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                            >
                                <tspan
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="tspan3484"
                                    x="253.227"
                                    y="-331"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="7"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                >
                                    DOOR2
                                </tspan>
                                <tspan
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="tspan3490"
                                    x="253.227"
                                    y="-322.25"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="7"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                >
                                    CNTAC
                                </tspan>
                            </text>
                            <g
                                id="g3538"
                                fillRule="evenodd"
                                stroke="#fff"
                                strokeLinecap="butt"
                                strokeLinejoin="miter"
                                strokeOpacity="1"
                                display="inline"
                            >
                                <path
                                    id="path3532"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    d="M235.155 316.588v1.945"
                                ></path>
                                <path
                                    id="path3534"
                                    fill="none"
                                    strokeWidth="0.748"
                                    d="M234.784 318.534l10.5-.022"
                                ></path>
                                <path
                                    id="path3536"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    d="M244.909 316.588v1.945"
                                ></path>
                            </g>
                            <g
                                id="g3530"
                                fillRule="evenodd"
                                stroke="#fff"
                                strokeLinecap="butt"
                                strokeLinejoin="miter"
                                strokeOpacity="1"
                                display="inline"
                            >
                                <path
                                    id="path3524"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    d="M247.341 316.588v1.945"
                                ></path>
                                <path
                                    id="path3526"
                                    fill="none"
                                    strokeWidth="0.748"
                                    d="M246.97 318.534l10.5-.022"
                                ></path>
                                <path
                                    id="path3528"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    d="M257.095 316.588v1.945"
                                ></path>
                            </g>
                        </g>
                        <g id="g902" transform="translate(-128.848 55.196)">
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text860"
                                x="225.204"
                                y="-331"
                                fill="#fff"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="7"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                            >
                                <tspan
                                    id="tspan856"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    x="225.204"
                                    y="-331"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="7"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                >
                                    AUX
                                </tspan>
                                <tspan
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="tspan858"
                                    x="225.204"
                                    y="-322.25"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="7"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                >
                                    IN3
                                </tspan>
                            </text>
                            <g
                                id="input34"
                                className="header"
                                transform="matrix(1 0 0 -1 0 612.16)"
                            >
                                <path
                                    id="input34Bg"
                                    fill="#63b47f"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M264.837 296.604h-37.07v18.952h37.07z"
                                    className="header-background"
                                ></path>
                                <path
                                    id="path864"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0v-2.554h-6.287V0h1.849v1.31h-3.621v13.125h9.661V1.31h-3.374V0z"
                                    transform="translate(260.399 300.031)"
                                ></path>
                                <path
                                    id="input4"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 100 2.667A1.333 1.333 0 000 0"
                                    transform="translate(257.294 305.81)"
                                ></path>
                                <path
                                    id="path868"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0v-2.554h-6.287V0h1.849v1.31h-3.621v13.125h9.661V1.31h-3.374V0z"
                                    transform="translate(249.472 300.031)"
                                ></path>
                                <path
                                    id="path870"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 100 2.667A1.333 1.333 0 000 0"
                                    transform="translate(246.366 305.81)"
                                ></path>
                                <path
                                    id="input3"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0v-2.554h-6.287V0h1.848v1.31h-3.62v13.125h9.661V1.31h-3.374V0z"
                                    transform="translate(238.544 300.031)"
                                ></path>
                                <path
                                    id="path874"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 100 2.667A1.333 1.333 0 000 0"
                                    transform="translate(235.439 305.81)"
                                ></path>
                            </g>
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text878"
                                x="-246.984"
                                y="321.008"
                                fill="#fff"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="7"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(-1 1)"
                                writingMode="vertical-lr"
                            >
                                <tspan
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="tspan876"
                                    x="-246.984"
                                    y="321.008"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="7"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                    writingMode="vertical-lr"
                                >
                                    COM
                                </tspan>
                            </text>
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text884"
                                x="253.227"
                                y="-331"
                                fill="#fff"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="7"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                            >
                                <tspan
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="tspan880"
                                    x="253.227"
                                    y="-331"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="7"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                >
                                    AUX
                                </tspan>
                                <tspan
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="tspan882"
                                    x="253.227"
                                    y="-322.25"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="7"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                >
                                    IN4
                                </tspan>
                            </text>
                            <g
                                id="g892"
                                fillRule="evenodd"
                                stroke="#fff"
                                strokeLinecap="butt"
                                strokeLinejoin="miter"
                                strokeOpacity="1"
                                display="inline"
                            >
                                <path
                                    id="path886"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    d="M235.155 316.588v1.945"
                                ></path>
                                <path
                                    id="path888"
                                    fill="none"
                                    strokeWidth="0.748"
                                    d="M234.784 318.534l10.5-.022"
                                ></path>
                                <path
                                    id="path890"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    d="M244.909 316.588v1.945"
                                ></path>
                            </g>
                            <g
                                id="g900"
                                fillRule="evenodd"
                                stroke="#fff"
                                strokeLinecap="butt"
                                strokeLinejoin="miter"
                                strokeOpacity="1"
                                display="inline"
                            >
                                <path
                                    id="path894"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    d="M247.341 316.588v1.945"
                                ></path>
                                <path
                                    id="path896"
                                    fill="none"
                                    strokeWidth="0.748"
                                    d="M246.97 318.534l10.5-.022"
                                ></path>
                                <path
                                    id="path898"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    d="M257.095 316.588v1.945"
                                ></path>
                            </g>
                        </g>
                        <g id="g950" transform="translate(-186.333 55.196)">
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text908"
                                x="225.204"
                                y="-331"
                                fill="#fff"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="7"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                            >
                                <tspan
                                    id="tspan904"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    x="225.204"
                                    y="-331"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="7"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                >
                                    REQ
                                </tspan>
                                <tspan
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="tspan906"
                                    x="225.204"
                                    y="-322.25"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="7"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                >
                                    EXIT
                                </tspan>
                            </text>
                            <g
                                id="input12"
                                className="header"
                                transform="matrix(1 0 0 -1 0 612.16)"
                            >
                                <path
                                    id="input12Bg"
                                    fill="#63b47f"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M264.837 296.604h-37.07v18.952h37.07z"
                                    className="header-background"
                                ></path>
                                <path
                                    id="input2"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0v-2.554h-6.287V0h1.849v1.31h-3.621v13.125h9.661V1.31h-3.374V0z"
                                    transform="translate(260.399 300.031)"
                                ></path>
                                <path
                                    id="path914"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 100 2.667A1.333 1.333 0 000 0"
                                    transform="translate(257.294 305.81)"
                                ></path>
                                <path
                                    id="path916"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0v-2.554h-6.287V0h1.849v1.31h-3.621v13.125h9.661V1.31h-3.374V0z"
                                    transform="translate(249.472 300.031)"
                                ></path>
                                <path
                                    id="path918"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 100 2.667A1.333 1.333 0 000 0"
                                    transform="translate(246.366 305.81)"
                                ></path>
                                <path
                                    id="input1"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0v-2.554h-6.287V0h1.848v1.31h-3.62v13.125h9.661V1.31h-3.374V0z"
                                    className="port"
                                    display="inline"
                                    transform="translate(238.544 300.031)"
                                ></path>
                                <path
                                    id="path922"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 100 2.667A1.333 1.333 0 000 0"
                                    display="inline"
                                    transform="translate(235.439 305.81)"
                                ></path>
                            </g>
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text926"
                                x="-247.36"
                                y="321.008"
                                fill="#fff"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="7"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(-1 1)"
                                writingMode="vertical-lr"
                            >
                                <tspan
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="tspan924"
                                    x="-247.36"
                                    y="321.008"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="7"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                    writingMode="vertical-lr"
                                >
                                    COM
                                </tspan>
                            </text>
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text932"
                                x="253.227"
                                y="-331"
                                fill="#fff"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="7"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                            >
                                <tspan
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="tspan928"
                                    x="253.227"
                                    y="-331"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="7"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                >
                                    DOOR1
                                </tspan>
                                <tspan
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="tspan930"
                                    x="253.227"
                                    y="-322.25"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="7"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                >
                                    CNTAC
                                </tspan>
                            </text>
                            <g
                                id="g940"
                                fillRule="evenodd"
                                stroke="#fff"
                                strokeLinecap="butt"
                                strokeLinejoin="miter"
                                strokeOpacity="1"
                                display="inline"
                            >
                                <path
                                    id="path934"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    d="M235.155 316.588v1.945"
                                ></path>
                                <path
                                    id="path936"
                                    fill="none"
                                    strokeWidth="0.748"
                                    d="M234.784 318.534l10.5-.022"
                                ></path>
                                <path
                                    id="path938"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    d="M244.909 316.588v1.945"
                                ></path>
                            </g>
                            <g
                                id="g948"
                                fillRule="evenodd"
                                stroke="#fff"
                                strokeLinecap="butt"
                                strokeLinejoin="miter"
                                strokeOpacity="1"
                                display="inline"
                            >
                                <path
                                    id="path942"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    d="M247.341 316.588v1.945"
                                ></path>
                                <path
                                    id="path944"
                                    fill="none"
                                    strokeWidth="0.748"
                                    d="M246.97 318.534l10.5-.022"
                                ></path>
                                <path
                                    id="path946"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    d="M257.095 316.588v1.945"
                                ></path>
                            </g>
                        </g>
                        <g
                            id="g102"
                            clipPath="url(#clipPath106)"
                            display="inline"
                            transform="translate(-97.81 81.931)"
                        >
                            <g
                                id="g4693"
                                fill="red"
                                strokeWidth="0.75"
                                fontFamily="monospace"
                                fontSize="8"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                            >
                                <text
                                    xmlSpace="preserve"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="text4857"
                                    x="122.367"
                                    y="-468.911"
                                    display="inline"
                                >
                                    <tspan
                                        id="tspan4855"
                                        style={{
                                            InkscapeFontSpecification: "'monospace, Normal'",
                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal",
                                        }}
                                        x="122.367"
                                        y="-468.911"
                                        fill="#fff"
                                        strokeWidth="0.75"
                                        fontFamily="monospace"
                                        fontSize="8"
                                        fontStretch="normal"
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight="normal"
                                    >
                                        D+
                                    </tspan>
                                </text>
                                <text
                                    xmlSpace="preserve"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="text4699"
                                    x="122.224"
                                    y="-457.717"
                                    display="inline"
                                >
                                    <tspan
                                        id="tspan4697"
                                        style={{
                                            InkscapeFontSpecification: "'monospace, Normal'",
                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal",
                                        }}
                                        x="122.224"
                                        y="-457.717"
                                        fill="#fff"
                                        strokeWidth="0.75"
                                        fontFamily="monospace"
                                        fontSize="8"
                                        fontStretch="normal"
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight="normal"
                                    >
                                        D-
                                    </tspan>
                                </text>
                                <text
                                    xmlSpace="preserve"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="text4573"
                                    x="122.288"
                                    y="-479.787"
                                    display="inline"
                                >
                                    <tspan
                                        id="tspan4571"
                                        style={{
                                            InkscapeFontSpecification: "'monospace, Normal'",
                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal",
                                        }}
                                        x="122.288"
                                        y="-479.787"
                                        fill="#fff"
                                        strokeWidth="0.75"
                                        fontFamily="monospace"
                                        fontSize="8"
                                        fontStretch="normal"
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight="normal"
                                    >
                                        12V+
                                    </tspan>
                                </text>
                                <text
                                    xmlSpace="preserve"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    id="text4683"
                                    x="122.512"
                                    y="-490.743"
                                    display="inline"
                                >
                                    <tspan
                                        id="tspan4681"
                                        style={{
                                            InkscapeFontSpecification: "'monospace, Normal'",
                                            fontVariantLigatures: "normal",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontVariantEastAsian: "normal",
                                        }}
                                        x="122.512"
                                        y="-490.743"
                                        fill="#fff"
                                        strokeWidth="0.75"
                                        fontFamily="monospace"
                                        fontSize="8"
                                        fontStretch="normal"
                                        fontStyle="normal"
                                        fontVariant="normal"
                                        fontWeight="normal"
                                    >
                                        GND-
                                    </tspan>
                                </text>
                            </g>
                            <g id="rs485Header" className="header">
                                <path
                                    id="rs485Bg"
                                    fill="#63b47f"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M120.732 452.984H101.78v48.085h18.952z"
                                    className="header-background"
                                    display="inline"
                                ></path>
                                <path
                                    id="path130"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0h2.554v-6.287H0v1.848h-1.309v-3.62h-13.126v9.66h13.126v-3.373H0z"
                                    display="inline"
                                    transform="translate(117.31 463.845)"
                                ></path>
                                <path
                                    id="path134"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
                                    display="inline"
                                    transform="translate(111.53 460.74)"
                                ></path>
                                <path
                                    id="path122"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.621h-13.126v9.661h13.126v-3.374H0z"
                                    display="inline"
                                    transform="translate(117.31 474.772)"
                                ></path>
                                <path
                                    id="path126"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
                                    display="inline"
                                    transform="translate(111.53 471.666)"
                                ></path>
                                <path
                                    id="path114"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.621h-13.126v9.661h13.126v-3.374H0z"
                                    display="inline"
                                    transform="translate(117.31 485.7)"
                                ></path>
                                <path
                                    id="path118"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
                                    display="inline"
                                    transform="translate(111.53 482.594)"
                                ></path>
                                <path
                                    id="path98"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.621h-13.126v9.661h13.126v-3.373H0z"
                                    display="inline"
                                    transform="translate(117.31 496.627)"
                                ></path>
                                <path
                                    id="path110"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
                                    display="inline"
                                    transform="translate(111.53 493.522)"
                                ></path>
                            </g>
                        </g>
                        <g id="g8645" transform="translate(-208.079 195.064)">
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text8633"
                                x="345.35"
                                y="-349.635"
                                fill="#fff"
                                strokeWidth="0.75"
                                display="inline"
                                fontFamily="monospace"
                                fontSize="8"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                                writingMode="vertical-lr"
                            >
                                <tspan id="tspan1091" x="345.35" y="-349.635">
                                    - +
                                </tspan>
                                <tspan id="tspan1093" x="355.35" y="-349.635">
                                    OUT
                                </tspan>
                                <tspan id="tspan1095" x="365.35" y="-349.635">
                                    12V
                                </tspan>
                            </text>
                            <g id="powerOutput" className="header">
                                <path
                                    id="path8635"
                                    fill="#63b47f"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M339.646 329.42h-18.952v26.117h18.952z"
                                    className="header-background"
                                ></path>
                                <path
                                    id="path8637"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.621h-13.126v9.661h13.126v-3.374H0z"
                                    transform="translate(336.217 340.17)"
                                ></path>
                                <path
                                    id="path8639"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
                                    transform="translate(330.438 337.065)"
                                ></path>
                                <path
                                    id="path8641"
                                    fill="#2c7039"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0h2.554v-6.287H0v1.849h-1.309v-3.62h-13.126v9.66h13.126v-3.373H0z"
                                    transform="translate(336.217 351.098)"
                                ></path>
                                <path
                                    id="path8643"
                                    fill="#be9a3a"
                                    fillOpacity="1"
                                    fillRule="nonzero"
                                    stroke="none"
                                    d="M0 0a1.333 1.333 0 10-2.667 0A1.333 1.333 0 000 0"
                                    transform="translate(330.438 347.993)"
                                ></path>
                            </g>
                        </g>
                    </g>
                    <g id="g3924">
                        <g id="g3882" transform="translate(-110.73 50.737)">
                            <text
                                id="text3872"
                                x="166.546"
                                y="-533.419"
                                fill="red"
                                strokeWidth="0.75"
                                fontSize="8"
                                transform="scale(1 -1)"
                                xmlSpace="preserve"
                            >
                                <tspan
                                    id="tspan3870"
                                    x="166.546"
                                    y="-533.419"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontSize="8"
                                >
                                    PWR
                                </tspan>
                            </text>
                            <path
                                id="pwrLED"
                                fill="red"
                                fillOpacity="1"
                                strokeWidth="0.75"
                                d="M320.579 -328.179H325.978V-324.20899999999995H320.579z"
                                className="led green-led"
                                transform="matrix(1 0 0 -1 -148.079 216.91)"
                            ></path>
                        </g>
                        <g id="g3906" transform="translate(-70.4 -119.476)">
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text3902"
                                x="169.577"
                                y="-533.139"
                                fill="red"
                                strokeWidth="0.75"
                                fontFamily="monospace"
                                fontSize="8"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                            >
                                <tspan
                                    id="tspan3900"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    x="169.577"
                                    y="-533.139"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="8"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                >
                                    D3
                                </tspan>
                            </text>
                            <path
                                id="d3LED"
                                fill="red"
                                strokeWidth="0.75"
                                d="M320.579 -328.179H325.978V-324.20899999999995H320.579z"
                                className="led red-led"
                                transform="matrix(1 0 0 -1 -148.079 216.91)"
                            ></path>
                        </g>
                        <g id="g3898" transform="translate(-130.077 -71.841)">
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text3894"
                                x="173.076"
                                y="-533.367"
                                fill="#fff"
                                strokeWidth="0.75"
                                fontFamily="monospace"
                                fontSize="8"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                            >
                                <tspan
                                    id="tspan3892"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    x="173.076"
                                    y="-533.367"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="8"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                >
                                    D2
                                </tspan>
                            </text>
                            <path
                                id="d2LED"
                                fill="#ffcd00"
                                fillOpacity="1"
                                strokeWidth="0.75"
                                d="M174.802 -545.487H180.201V-541.5169999999999H174.802z"
                                className="led yellow-led"
                                transform="scale(1 -1)"
                            ></path>
                        </g>
                        <g id="g3890" transform="translate(-144.392 -71.841)">
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "'monospace, Normal'",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text3886"
                                x="172.441"
                                y="-533.367"
                                fill="#fff"
                                strokeWidth="0.75"
                                fontFamily="monospace"
                                fontSize="8"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                            >
                                <tspan
                                    id="tspan3884"
                                    style={{
                                        InkscapeFontSpecification: "'monospace, Normal'",
                                        fontVariantLigatures: "normal",
                                        fontVariantCaps: "normal",
                                        fontVariantNumeric: "normal",
                                        fontVariantEastAsian: "normal",
                                    }}
                                    x="172.441"
                                    y="-533.367"
                                    fill="#fff"
                                    strokeWidth="0.75"
                                    fontFamily="monospace"
                                    fontSize="8"
                                    fontStretch="normal"
                                    fontStyle="normal"
                                    fontVariant="normal"
                                    fontWeight="normal"
                                >
                                    D1
                                </tspan>
                            </text>
                            <path
                                id="d1LED"
                                fill="#7fff2a"
                                fillOpacity="1"
                                strokeWidth="0.75"
                                d="M174.802 -545.487H180.201V-541.5169999999999H174.802z"
                                className="led green-led green-led-slow"
                                transform="scale(1 -1)"
                            ></path>
                        </g>
                        <g id="g10153" transform="translate(-132.927 -8.487)">
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "monospace",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text10149"
                                x="214.329"
                                y="-553.938"
                                fill="#fff"
                                strokeWidth="0.75"
                                fontFamily="monospace"
                                fontSize="8"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                            >
                                <tspan id="tspan10155" x="214.329" y="-553.938">
                                    Tx
                                </tspan>
                            </text>
                            <path
                                id="rect10151"
                                fill="#ffcd00"
                                fillOpacity="1"
                                strokeWidth="0.75"
                                d="M225.894 -558.008H231.293V-554.038H225.894z"
                                className="led yellow-led yellow-led-fast"
                                transform="scale(1 -1)"
                            ></path>
                        </g>
                        <g id="g10163" transform="translate(-132.927 -18.9)">
                            <text
                                xmlSpace="preserve"
                                style={{
                                    InkscapeFontSpecification: "monospace",
                                    fontVariantLigatures: "normal",
                                    fontVariantCaps: "normal",
                                    fontVariantNumeric: "normal",
                                    fontVariantEastAsian: "normal",
                                }}
                                id="text10159"
                                x="214.329"
                                y="-553.938"
                                fill="#fff"
                                strokeWidth="0.75"
                                fontFamily="monospace"
                                fontSize="8"
                                fontStretch="normal"
                                fontStyle="normal"
                                fontVariant="normal"
                                fontWeight="normal"
                                transform="scale(1 -1)"
                            >
                                <tspan id="tspan10165" x="214.329" y="-553.938">
                                    Rx
                                </tspan>
                            </text>
                            <path
                                id="rect10161"
                                fill="#7fff2a"
                                fillOpacity="1"
                                strokeWidth="0.75"
                                d="M225.894 -558.008H231.293V-554.038H225.894z"
                                className="led yellow-led green-led green-led-fast"
                                transform="scale(1 -1)"
                            ></path>
                        </g>
                    </g>
                    <g
                        id="dipswitch"
                        display="inline"
                        transform="translate(-93.414 69.999)"
                    >
                        <path
                            id="path72-6"
                            fill="#acaaaa"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            d="M165.656 378.5h-3.322v31.008h3.322z"
                        ></path>
                        <path
                            id="path74-3"
                            fill="#acaaaa"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            d="M172.217 378.5h-3.323v31.008h3.323z"
                        ></path>
                        <path
                            id="path76-9"
                            fill="#acaaaa"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            d="M178.812 378.455h-3.322v31.008h3.322z"
                        ></path>
                        <path
                            id="path78-2"
                            fill="#acaaaa"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            d="M184.984 378.455h-3.322v31.008h3.322z"
                        ></path>
                        <path
                            id="path80-2"
                            fill="#acaaaa"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            d="M191.342 378.455h-3.323v31.008h3.323z"
                        ></path>
                        <path
                            id="path440-7"
                            fill="#32312c"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            strokeWidth="0.978"
                            d="M193.54 383.418h-34.344v21.08h34.344z"
                        ></path>
                        <text
                            id="text464-9"
                            fill="#fff"
                            fillOpacity="1"
                            fillRule="nonzero"
                            stroke="none"
                            fontFamily="monospace"
                            fontSize="4"
                            fontStretch="normal"
                            fontVariant="normal"
                            fontWeight="normal"
                            transform="matrix(1 0 0 -1 163.143 384.25)"
                            xmlSpace="preserve"
                            style={{ InkscapeFontSpecification: "monospace" }}
                        >
                            <tspan
                                id="tspan462-5"
                                x="0 2.052 6.2919998 8.3439999 12.584 14.636 18.875999 20.927999 25.167999"
                                y="0"
                            >
                                1 2 3 4 5
                            </tspan>
                        </text>
                        <g id="sw1" className="switch">
                            <path
                                id="sw1Bg"
                                fill="#000"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M166.027 387.752h-3.694v14.171h3.694z"
                            ></path>
                            <path
                                id="sw1Off"
                                fill="#ddd"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M165.656 389.117h-2.951v2.951h2.95z"
                                className="off"
                                display="inline"
                            ></path>
                            <path
                                id="sw1On"
                                fill="#ddd"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M165.656 397.612h-2.951v2.951h2.951z"
                                className="on"
                                display="inline"
                            ></path>
                        </g>
                        <g id="sw2" className="switch">
                            <path
                                id="sw2Bg"
                                fill="#000"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M172.402 387.752h-3.694v14.171h3.694z"
                            ></path>
                            <path
                                id="sw2Off"
                                fill="#ddd"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M172.031 389.117h-2.951v2.951h2.951z"
                                className="off"
                            ></path>
                            <path
                                id="sw2On"
                                fill="#ddd"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M172.03 397.612h-2.95v2.951h2.95z"
                                className="on"
                                display="inline"
                            ></path>
                        </g>
                        <g id="sw3" className="switch">
                            <path
                                id="sw3Bg"
                                fill="#000"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M178.777 387.752h-3.694v14.171h3.694z"
                            ></path>
                            <path
                                id="sw3Off"
                                fill="#ddd"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M178.406 389.117h-2.951v2.951h2.951z"
                                className="off"
                            ></path>
                            <path
                                id="sw3On"
                                fill="#ddd"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M178.406 397.612h-2.951v2.951h2.95z"
                                className="on"
                                display="inline"
                            ></path>
                        </g>
                        <g id="sw4" className="switch">
                            <path
                                id="sw4Bg"
                                fill="#000"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M185.152 387.752h-3.694v14.171h3.694z"
                            ></path>
                            <path
                                id="sw4Off"
                                fill="#ddd"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M184.781 389.117h-2.951v2.951h2.951z"
                                className="off"
                            ></path>
                            <path
                                id="sw4On"
                                fill="#ddd"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M184.78 397.612h-2.95v2.951h2.95z"
                                className="on"
                                display="inline"
                            ></path>
                        </g>
                        <g id="sw5" className="switch">
                            <path
                                id="sw5Bg"
                                fill="#000"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M191.527 387.752h-3.694v14.171h3.694z"
                            ></path>
                            <path
                                id="sw5Off"
                                fill="#ddd"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M191.156 389.117h-2.951v2.951h2.951z"
                                className="off"
                            ></path>
                            <path
                                id="sw5On"
                                fill="#ddd"
                                fillOpacity="1"
                                fillRule="nonzero"
                                stroke="none"
                                d="M191.156 397.612h-2.951v2.951h2.95z"
                                className="on"
                                display="inline"
                            ></path>
                        </g>
                    </g>
                </g>
            </svg>
        );
    }
}